import Select from 'antd/es/select';

const { Option } = Select;

export default Option;
